import axios from "axios";
const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const submitContact = (data) => axios.post(`${API}/contact`, data).then(r => r.data);
export const submitTraining = (data) => axios.post(`${API}/training`, data).then(r => r.data);
export const submitEvent = (data) => axios.post(`${API}/events`, data).then(r => r.data);
export const submitBook = (data) => axios.post(`${API}/book/reserve`, data).then(r => r.data);
export const submitAI = (data) => axios.post(`${API}/ai/consult`, data).then(r => r.data);
export const submitAssessment = (data) => axios.post(`${API}/assessment`, data).then(r => r.data);
export const submitWorkWith = (data) => axios.post(`${API}/work-with`, data).then(r => r.data);
export const submitFoundation = (data) => axios.post(`${API}/foundation`, data).then(r => r.data);
export const submitSpeaking = (data) => axios.post(`${API}/speaking`, data).then(r => r.data);
export const getAuctionPackages = () => axios.get(`${API}/auction/packages`).then(r => r.data);
export const applyAuction = (data) => axios.post(`${API}/auction/apply`, data).then(r => r.data);
export const joinWaitingList = (data) => axios.post(`${API}/auction/waiting-list`, data).then(r => r.data);
export const getNyeTiers = () => axios.get(`${API}/nye/tiers`).then(r => r.data);
export const createNyeCheckout = (data) => axios.post(`${API}/nye/checkout`, data).then(r => r.data);
export const getNyeStatus = (sessionId) => axios.get(`${API}/nye/status/${sessionId}`).then(r => r.data);
export const getNyeTicket = (sessionId) => axios.get(`${API}/nye/ticket/${sessionId}`).then(r => r.data);
export const registerWebinar = (data) => axios.post(`${API}/webinar/register`, data).then(r => r.data);
export const createWebinarUpsell = (data) => axios.post(`${API}/webinar/upsell`, data).then(r => r.data);
export const getWebinarUpsellStatus = (sessionId) => axios.get(`${API}/webinar/upsell/status/${sessionId}`).then(r => r.data);
